import styled, { css } from 'styled-components';
import { Link } from 'react-router-dom';
const LinkStyles = css `
  cursor: pointer;
  text-decoration: none;
  font-size: ${({ fontSize }) => fontSize || 1.6}rem;
  font-family: ${({ theme }) => theme.fonts.primaryBold};
  color: ${({ theme, color }) => color || theme.colors.interactive.brandColor};
  &:visited {
    color: ${({ theme, color }) => color || theme.colors.interactive.brandColor};
  }

  ${({ theme }) => {
    const color = theme.colors.interactive.brandColor;
    return theme.media.laptop `
    &:hover {
      color: ${color}
    }
    `;
}}
`;
export const CustomLink = styled(Link) `
  ${LinkStyles}
`;
export const CustomOuterLink = styled.a `
  ${LinkStyles}
`;
//# sourceMappingURL=styles.js.map